import React from 'react';

function PgaSobre() {
    return (
        <div className="min-h-screen bg-background text-white">
            <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12 py-12">
                {/* Main Heading */}
                <div className="text-center mb-12">
                    <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4">
                        Sobre
                    </h1>
                    <div className="w-24 h-1 bg-teal-400 mx-auto rounded-full"></div>
                </div>

                {/* Content Section */}
                <div className="space-y-8">
                    {/* SMIZE TV Section */}
                    <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-8 border border-gray-700/50">
                        <h3 className="text-2xl font-bold text-teal-300 mb-6">
                            A SMIZE TV
                        </h3>
                        <p className="text-gray-300 text-lg leading-relaxed">
                            Transmitimos os melhores canais ENTRETENIMENTO, TEATRO E MÚSICA para sua comodidade e segurança
                        </p>
                    </div>

                    {/* Support Info Section */}
                    <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-8 border border-gray-700/50">
                        <p className="text-gray-300 text-lg leading-relaxed mb-6">
                            Para duvidas, suporte ou criar um canal ligue
                        </p>
                        
                        {/* Warning Section */}
                        <div className="bg-red-900/20 border border-red-500/30 rounded-xl p-6 mb-8">
                            <h4 className="text-xl font-bold text-red-400 mb-4 flex items-center">
                                <svg className="w-6 h-6 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                </svg>
                                NÃO CAIA EM GOLPES!
                            </h4>
                        </div>

                        {/* Creator Info */}
                        <div className="space-y-4">
                            <p className="text-gray-300 text-lg leading-relaxed">
                                A Smize TV foi criada por Rodrigo Adelino, da empresa Bascode (21) 99885-1057
                            </p>
                            
                            <div className="flex items-center">
                                <svg className="w-5 h-5 text-teal-400 mr-3" fill="currentColor" viewBox="0 0 20 20">
                                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                </svg>
                                <a 
                                    href="mailto:rodrigo@bascode.com" 
                                    className="text-teal-400 hover:text-teal-300 transition-colors duration-200"
                                >
                                    rodrigo@bascode.com
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* WhatsApp Contact */}
                    <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-8 border border-gray-700/50 text-center">
                        <a
                            href={`https://wa.me/${import.meta.env.VITE_WHATSAPP_NUMBER || '5521998851057'}?text=Ol%C3%A1%21%20Gostaria%20de%20receber%20mais%20informa%C3%A7%C3%B5es%20sobre%20a%20Smize%20TV.%20Pode%20me%20ajudar%3F`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center justify-center bg-[#25D366] hover:bg-[#1EBE5F] active:bg-[#169E4F] text-white text-lg font-semibold py-4 px-8 rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 focus:outline-none focus:ring-4 focus:ring-green-500/50"
                        >
                            <img
                                src={import.meta.env.VITE_WHATSAPP_ICON || "https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"}
                                alt="WhatsApp"
                                className="mr-3 w-6 h-6"
                            />
                            Fale conosco pelo WhatsApp
                        </a>
                    </div>

                    {/* Footer */}
                    <div className="text-center py-8">
                        <p className="text-gray-400 text-lg font-light">
                            Streamize TV
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PgaSobre;